import React from 'react';

const API_ORIGIN = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1').replace(/\/api\/v1$/, '');

// Envolve a página pública da enquete (FormularioDinamico.js — tela de
// perguntas e tela de "obrigado") com o fundo personalizado escolhido no
// admin (ver PersonalizarFundoForm.js). Cor troca o fundo padrão direto;
// imagem entra como uma camada por trás do conteúdo com opacidade baixa
// fixa (opacity-10, não é configurável pelo admin de propósito — evita
// alguém sem querer deixar ilegível). Sem fundo_tipo definido ou 'nenhum',
// vira só o bg-corumba-light de sempre.
const FundoPersonalizado = ({ enquete, children }) => {
  // `fundo` guarda cor OU imagem (nunca os dois) — fundo_tipo diz qual é,
  // não precisa inferir pelo formato da string (ver EnqueteDinamica.js).
  const estiloCor = enquete?.fundo_tipo === 'cor' && enquete.fundo
    ? { backgroundColor: enquete.fundo }
    : undefined;
  const temImagem = enquete?.fundo_tipo === 'imagem' && !!enquete.fundo;

  return (
    <div className="min-h-screen bg-corumba-light relative" style={estiloCor}>
      {temImagem && (
        <div
          className="absolute inset-0 opacity-10 pointer-events-none bg-cover bg-center"
          style={{ backgroundImage: `url(${API_ORIGIN}${enquete.fundo})` }}
          aria-hidden="true"
        />
      )}
      {/* min-h-screen flex flex-col aqui (não só no wrapper de fora) —
          senão o rodapé (FooterPublico, com mt-auto no ponto onde é usado)
          não tem um container flex de verdade pra empurrar ele até embaixo,
          e sobra fundo colorido vazio abaixo do rodapé em página curta
          (só não aparecia antes porque bg-corumba-light é quase invisível
          contra o fundo branco da página; com uma cor personalizada, o
          buraco fica óbvio). */}
      <div className="relative z-10 min-h-screen flex flex-col">{children}</div>
    </div>
  );
};

export default FundoPersonalizado;
